import { useEffect, useState, useCallback } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

/**
 * Fetches /api/dashboard/sparklines for the chosen range.
 * Returns { data, loading, range, setRange, reload }.
 */
export function useSparklines(initialDays = 7) {
    const [range, setRange] = useState(initialDays);
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);

    const load = useCallback(async (days) => {
        setLoading(true);
        try {
            const res = await axios.get(`${API}/api/dashboard/sparklines?days=${days}`);
            setData(res.data);
        } catch (e) {
            console.error('Sparklines load error:', e);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => { load(range); }, [range, load]);

    return { data, loading, range, setRange, reload: () => load(range) };
}
